var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainsizing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.316,
    height: 23.402,
    viewBox: "0 0 41.316 23.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-199 545)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199 -545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.226-521.6H199V-545h3.226v11.468l.1.036,8.09-8.091,2.316,2.321-4.264,4.249h22.459l-4.284-4.279,2.324-2.326,8.125,8.126V-545h3.228v23.4h-3.228v-11.664l-.12-.05-8.1,8.1-2.266-2.282,4.252-4.242H208.306l4.3,4.289-2.3,2.334-8.073-8.073Z",
    transform: "translate(-199 545)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainsizing);
export default __webpack_public_path__ + "static/media/mainـsizing.ccc0b48f43382f1df3eae1831b7afc9f.svg";
export { ForwardRef as ReactComponent };